import { render, staticRenderFns } from "./appAdress.vue?vue&type=template&id=090b8c93&scoped=true&"
import script from "./appAdress.vue?vue&type=script&lang=js&"
export * from "./appAdress.vue?vue&type=script&lang=js&"
import style0 from "./appAdress.vue?vue&type=style&index=0&id=090b8c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b8c93",
  null
  
)

export default component.exports